module.exports = __webpack_public_path__ + "fonts/HelveticaNeue.ccad04d4.ttf";